// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O3ED","content":"styles_content__1Y1ih"};